import React from "react";
import { oneOfType, string, bool, shape } from "prop-types";

import * as i18n from "util/i18n";
import "react-circular-progressbar/dist/styles.css";
import CustomTabs from "pages/_components/CustomTabs/CustomTabs";
import Fees from "./Fees";

const LoanDetailFees = ({ isDesktop, detallePrestamo }) => {
    const { cuotas } = detallePrestamo;
    const tabsData = [
        {
            text: i18n.get("menu.loans.detail.cuotasActivas", "Cuotas pendientes"),
            textType: "",
        },
        {
            text: i18n.get("menu.loans.detail.cuotasPagadas", "Cuotas pagadas"),
            textType: "",
        },
    ];

    return (
        <CustomTabs tabsData={tabsData} defaultTab={0}>
            <Fees isDesktop={isDesktop} fees={cuotas} detallePrestamo={detallePrestamo} feeType="A" />

            <Fees isDesktop={isDesktop} fees={cuotas} detallePrestamo={detallePrestamo} feeType="P" />
        </CustomTabs>
    );
};

LoanDetailFees.propTypes = {
    detallePrestamo: shape({}).isRequired,
    isDesktop: oneOfType([string, bool]),
};

LoanDetailFees.defaultProps = {
    isDesktop: false,
};

export default LoanDetailFees;
